var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_vm._v(" "),_c('router-view',{staticStyle:{"margin-top":"120px"}}),_vm._v(" "),_c('Footer'),_vm._v(" "),_c('GoTop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }